import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { HelperService } from 'src/app/services/Helper/helper.service';

@Component({
  selector: 'app-edit-provider',
  templateUrl: './edit-provider.component.html',
  styleUrls: ['./edit-provider.component.css']
})
export class EditProviderComponent implements OnInit {
  isAuthorized: string;

  providers: any[];
  rejectedProviders: any[];
  suspendedProviders: any[];
  contractTypes: any[];
  roles: any[];
  status: any[];
  countries: any[];

  constructor(private helper: HelperService, private lookupService: LookupService, private registrationService: RegistrationService) { }

  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    if(this.isAuthorized === "true") {
      this.helper.setTitle('Provider - Edit Provider');

      this.lookupService.getApprovedProviders().subscribe(data => this.providers = data);
      this.lookupService.getRejectedProviders().subscribe(data => this.rejectedProviders = data);
      this.lookupService.getSuspendedProviders().subscribe(data => this.suspendedProviders = data);
      this.lookupService.getContractTypes().subscribe(data => this.contractTypes = data);
      this.lookupService.getRoles().subscribe(data => this.roles = data);
      this.lookupService.getStatus().subscribe(data => this.status = data);
      this.lookupService.getCountries().subscribe(data => this.countries = data);
      
      this.openPage('Approved');
    }
    else
      location.assign("#/login-form");
  }

  openPage(pageName) {
    // Declare all variables
    var i, tabcontent;
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(pageName).style.display = "block";
  
    if(pageName==="Approved") {
      document.getElementById("approvedBtn").style.backgroundColor = "crimson";
      document.getElementById("approvedBtn").style.color = "white";
      document.getElementById("rejectedBtn").style.backgroundColor = "white";
      document.getElementById("rejectedBtn").style.color = "black";
      document.getElementById("suspendedBtn").style.backgroundColor = "white";
      document.getElementById("suspendedBtn").style.color = "black";
    } else if(pageName ==="Rejected") {
      document.getElementById("rejectedBtn").style.backgroundColor = "crimson";
      document.getElementById("rejectedBtn").style.color = "white";
      document.getElementById("approvedBtn").style.backgroundColor = "white";
      document.getElementById("approvedBtn").style.color = "black";
      document.getElementById("suspendedBtn").style.backgroundColor = "white";
      document.getElementById("suspendedBtn").style.color = "black";
    } else if(pageName ==="Suspended") {
      document.getElementById("suspendedBtn").style.backgroundColor = "crimson";
      document.getElementById("suspendedBtn").style.color = "white";
      document.getElementById("rejectedBtn").style.backgroundColor = "white";
      document.getElementById("rejectedBtn").style.color = "black";
      document.getElementById("approvedBtn").style.backgroundColor = "white";
      document.getElementById("approvedBtn").style.color = "black";
    }
    }

  suspendProvider(e) {
    this.registrationService.suspendProvider(e.key).subscribe(data => this.displayResult(data));
  }

  unsuspendProvider(e) {
    this.registrationService.unsuspendProvider(e.key).subscribe(data=> this.displayResult(data));
  }

  updateProvider(e) {
    this.registrationService.updateProvider(e.key).subscribe(data => this.displayResult(data));
  }

  displayResult(data) {
    alert(data);
    setTimeout(() => {
      location.reload();
    }, 500);
  }
}